/**
 * The COMMS card family's short damage-type codes (`comms-attack-reaction-cards` 3.1/4.1): `KIN`,
 * `EXP`, `ENG`, `BURN`, `HEAT`. The reaction tiles read them now; the attack card is meant to read
 * the same table. Deliberately separate from `weaponFormat.ts`'s older weapon-card tags
 * (`NRG`/`BRN`), which that project leaves alone. An unknown type falls back to upper case.
 */
const CODES: Record<string, string> = {
  kinetic: "KIN",
  explosive: "EXP",
  energy: "ENG",
  burn: "BURN",
  heat: "HEAT",
  variable: "VAR",
};

export function damageTypeCode(type: string): string {
  return CODES[type] ?? type.toUpperCase();
}
